import { colorPalette } from '../../../colorPalette';
export const getCardPartnerStyles = (variant, backgroundColor) => ({
    container: {
        width: '178px',
        backgroundColor: colorPalette.white,
        borderRadius: '8px',
        border: `1px solid ${colorPalette.gray200}`,
        cursor: 'pointer',
        ':hover': {
            boxShadow: `0px 0px 16px 0px ${colorPalette.gray300}80`,
        },
        overflow: 'hidden',
    },
    logoContainer: {
        position: 'relative',
        backgroundColor: `${backgroundColor}`,
        padding: ['LogoOnly', 'LogoCard'].includes(variant) ? '16px' : '0px',
    },
    logo: {
        margin: variant === 'LogoCard' ? '8px 0' : '0',
        padding: '0 8px',
        width: '100%',
        height: ['LogoOnly', 'LogoCard'].includes(variant) ? '46px' : '72px',
        objectFit: 'contain',
    },
    miniLogo: {
        borderRadius: '4px',
        backgroundColor: `${backgroundColor}`,
        position: 'absolute',
        top: '8px',
        left: '8px',
        width: '32px',
        height: '32px',
        objectFit: 'contain',
        padding: '4px',
    },
    banner: {
        width: '100%',
        height: variant === 'TopPartner' ? '90px' : '70px',
        objectFit: 'cover',
    },
    contentContainer: {
        margin: variant === 'LogoOnly' ? 'auto' : 'initial',
        padding: variant === 'LogoOnly' ? '16px' : '12px',
    },
    categoryLabel: {
        color: `${colorPalette.gray700}`,
        textTransform: 'uppercase',
        marginBottom: '2px',
    },
    contentLabel: {
        color: `${colorPalette.gray900}`,
        marginBottom: '12px',
        whiteSpace: variant === 'TopPartner' ? 'initial' : 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '144px',
    },
});
